var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconBarcodeScan = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  x: "0px",
  y: "0px",
  viewBox: "0 0 512 512",
  style: {
    enableBackground: "new 0 0 512 512"
  },
  xmlSpace: "preserve",
  className: "icon icon--barcode-scan",
  ref: svgRef
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#2F96FF;}\n\t.st1{fill:#FB2E3F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M463.6,68.9h-31.2c-5.7,0-10.4,4.7-10.4,10.4c0,5.7,4.7,10.4,10.4,10.4h31.2c11.5,0,20.7,9.3,20.7,20.7v31.2 c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4v-31.2C505.2,87.5,486.6,68.9,463.6,68.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M17.1,151.9c5.7,0,10.4-4.7,10.4-10.4v-31.2c0-11.5,9.3-20.7,20.7-20.7h31.2c5.7,0,10.4-4.7,10.4-10.4 s-4.7-10.4-10.4-10.4H48.3c-23,0.1-41.6,18.7-41.6,41.7v31.2C6.7,147.3,11.4,151.9,17.1,151.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M494.8,359.7c-5.7,0-10.4,4.7-10.4,10.4v31.2c0,11.5-9.3,20.7-20.7,20.7h-31.2c-5.7,0-10.4,4.7-10.4,10.4 s4.7,10.4,10.4,10.4h31.2c22.9,0,41.6-18.6,41.6-41.6v-31.2C505.2,364.3,500.5,359.7,494.8,359.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M79.4,422H48.3c-11.5,0-20.7-9.3-20.7-20.7v-31.2c0-5.7-4.7-10.4-10.4-10.4S6.7,364.3,6.7,370v31.2 c0,23,18.6,41.6,41.6,41.6h31.2c5.7,0,10.4-4.7,10.4-10.4S85.2,422,79.4,422z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M79.4,131.2c-5.7,0-10.4,4.7-10.4,10.4v228.5c0,5.7,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4V141.6 C89.8,135.9,85.2,131.2,79.4,131.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M287.1,131.2c-5.7,0-10.4,4.7-10.4,10.4v228.5c0,5.7,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4V141.6 C297.5,135.9,292.9,131.2,287.1,131.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M432.5,131.2c-5.7,0-10.4,4.7-10.4,10.4v228.5c0,5.7,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4V141.6 C442.9,135.9,438.2,131.2,432.5,131.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M141.7,131.2c-5.7,0-10.4,4.7-10.4,10.4v166.2c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4V141.6 C152.1,135.9,147.5,131.2,141.7,131.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M183.2,131.2c-5.7,0-10.4,4.7-10.4,10.4v166.2c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4V141.6 C193.6,135.9,189,131.2,183.2,131.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M224.8,131.2c-5.7,0-10.4,4.7-10.4,10.4v166.2c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4V141.6 C235.2,135.9,230.5,131.2,224.8,131.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M328.7,131.2c-5.7,0-10.4,4.7-10.4,10.4v166.2c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4V141.6 C339,135.9,334.4,131.2,328.7,131.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M391,131.2c-5.7,0-10.4,4.7-10.4,10.4v166.2c0,5.7,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4V141.6 C401.3,135.9,396.7,131.2,391,131.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M391,338.9c-5.7,0-10.4,4.7-10.4,10.4V370c0,5.7,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4v-20.7 C401.3,343.5,396.7,338.9,391,338.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M328.7,338.9c-5.7,0-10.4,4.7-10.4,10.4V370c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4v-20.7 C339,343.5,334.4,338.9,328.7,338.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M224.8,338.9c-5.7,0-10.4,4.7-10.4,10.4V370c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4v-20.7 C235.2,343.5,230.5,338.9,224.8,338.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M183.2,338.9c-5.7,0-10.4,4.7-10.4,10.4V370c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4v-20.7 C193.6,343.5,189,338.9,183.2,338.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M141.7,338.9c-5.7,0-10.4,4.7-10.4,10.4V370c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4v-20.7 C152.1,343.5,147.5,338.9,141.7,338.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M494.8,235.1h-51.9v-93.5c0-5.7-4.7-10.4-10.4-10.4s-10.4,4.7-10.4,10.4v93.5h-20.7v-93.5 c0-5.7-4.7-10.4-10.4-10.4c-5.7,0-10.4,4.7-10.4,10.4v93.5h-41.6v-93.5c0-5.7-4.7-10.4-10.4-10.4c-5.7,0-10.4,4.7-10.4,10.4v93.5 h-20.7v-93.5c0-5.7-4.7-10.4-10.4-10.4s-10.4,4.7-10.4,10.4v93.5h-41.6v-93.5c0-5.7-4.7-10.4-10.4-10.4c-5.7,0-10.4,4.7-10.4,10.4 v93.5h-20.4v-93.5c0-5.7-4.7-10.4-10.4-10.4c-5.7,0-10.4,4.7-10.4,10.4v93.5h-20.7v-93.5c0-5.7-4.7-10.4-10.4-10.4 c-5.7,0-10.4,4.7-10.4,10.4v93.5H89.8v-93.5c0-5.7-4.7-10.4-10.4-10.4c-5.7,0-10.4,4.7-10.4,10.4v93.5H17.1 c-5.7,0-10.4,4.7-10.4,10.4c0,5.7,4.7,10.4,10.4,10.4H69v114.2c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4V255.8h41.5 v51.9c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4v-51.9h20.7v51.9c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4 v-51.9h20.7v51.9c0,5.7,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4v-51.9h41.6V370c0,5.7,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4V255.8 h20.5v51.9c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4v-51.9h41.5v51.9c0,5.7,4.7,10.4,10.4,10.4s10.4-4.7,10.4-10.4 v-51.9h20.7V370c0,5.7,4.7,10.4,10.4,10.4c5.7,0,10.4-4.7,10.4-10.4V255.8h51.9C508.3,256,508.3,234.9,494.8,235.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M494.8,235.1H17.1c-5.7,0-10.4,4.7-10.4,10.4c0,5.7,4.7,10.4,10.4,10.4h477.8c5.7,0,10.4-4.7,10.4-10.4 C505.2,239.6,500.5,235.1,494.8,235.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M141.7,338.9c-5.7,0-10.4,4.7-10.4,10.4c1,9-4.6,31.4,10.4,31.2c5.7,0,10.4-4.7,10.4-10.4 C151.2,361.2,156.6,338.8,141.7,338.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M183.2,338.9c-5.7,0-10.4,4.7-10.4,10.4c1,9-4.6,31.4,10.4,31.2c5.7,0,10.4-4.7,10.4-10.4 C192.7,361.2,198.2,338.8,183.2,338.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M224.8,338.9c-5.7,0-10.4,4.7-10.4,10.4c1,9-4.6,31.4,10.4,31.2c5.7,0,10.4-4.7,10.4-10.4 C234.2,361.2,239.7,338.8,224.8,338.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M79.4,422c-52.4,1.2-53.1,0.4-51.9-51.9c0.2-13.4-21-13.5-20.7,0v31.2c2.1,42.4,39.4,43.2,72.6,41.5 C92.9,442.9,92.9,421.8,79.4,422z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M17.1,151.9c26.1-2-9-59.8,31.2-62.3h31.2c5.7,0,10.4-4.7,10.4-10.4s-4.7-10.4-10.4-10.4H48.3 c-23,0.1-41.6,18.7-41.6,41.7v31.2C6.7,147.3,11.4,151.9,17.1,151.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M463.6,68.9h-31.2c-5.7,0-10.4,4.7-10.4,10.4c0,5.7,4.7,10.4,10.4,10.4h31.2c40.1,2.5,5,60.2,31.2,62.3 c5.7,0,10.4-4.7,10.4-10.4v-31.2C505.2,87.5,486.6,68.9,463.6,68.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M328.7,338.9c-5.7,0-10.4,4.7-10.4,10.4c1,9-4.6,31.4,10.4,31.2c5.7,0,10.4-4.7,10.4-10.4 C338.1,361.2,343.6,338.8,328.7,338.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M494.8,359.7c-26.1,2,9,59.8-31.2,62.3h-31.2c-5.7,0-10.4,4.7-10.4,10.4s4.7,10.4,10.4,10.4h31.2 c22.9,0,41.6-18.6,41.6-41.6v-31.2C505.2,364.3,500.5,359.7,494.8,359.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M391,338.9c-5.7,0-10.4,4.7-10.4,10.4c1,9-4.6,31.4,10.4,31.2c5.7,0,10.4-4.7,10.4-10.4 C400.4,361.2,405.9,338.8,391,338.9z"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBarcodeScan, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconBarcodeScan.3eb1db8c.svg";
export { ForwardRef as ReactComponent };